export default __webpack_public_path__ + "static/media/dog-orange.c6a916a9.svg";